
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import Auth from "@/lib/common/auth";
import gateway from "@/lib/request/gateway";
import HinaRadioGroup from "../baseComponent/hina-radio-group.vue";

// 每个子组件表单：

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard,
    HinaRadioGroup
  }
})
export default class HandCheck extends Vue {
  @Prop({}) formItemData!: any; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源
  @Prop({}) setWeb!: boolean;

  validFail = false;

  videoUploadOptions = [
    { name: "推流上传", value: 0 }
    // 不再使用文件上传方式
    // { name: "文件上传", value: 1 }
  ];

  listArray = ["左手背", "左手心", "左握拳", "右手背", "右手心", "右握拳"];

  trialOne() {
    this.$emit("trial", "handDetection");
  }

  get token() {
    return Auth.token;
  }

  get configData() {
    return this.formItemData.handDetection.configData;
  }

  get bodyConfigData() {
    return this.formItemData.bodyDetection.configData;
  }

  get hasDetectItem() {
    const {
      fingerCheckTestComplete,
      fingerCheckTestFlexible,
      fingerCheckTestScar,
      armCheckTestHide,
      armCheckTestComplete
    } = this.formItemData.handDetection.configData;
    return (
      fingerCheckTestComplete ||
      fingerCheckTestFlexible ||
      fingerCheckTestScar ||
      armCheckTestHide ||
      armCheckTestComplete
    );
  }

  get canTrial() {
    return (
      this.formItemData.handDetection.use === 1 &&
      this.hasDetectItem &&
      this.builder !== "MOKA_V2"
    );
  }

  get hasTip() {
    const {
      noRollUpSleevesConfig,
      noArmCompleteConfig,
      armCheckTestComplete,
      armCheckTestHide
    } = this.configData;
    return (
      (armCheckTestHide && noRollUpSleevesConfig.operate !== 0) ||
      (armCheckTestComplete && noArmCompleteConfig.operate !== 0)
    );
  }

  get hasCut() {
    const {
      noRollUpSleevesConfig,
      noArmCompleteConfig,
      armCheckTestComplete,
      armCheckTestHide
    } = this.configData;
    return (
      (noRollUpSleevesConfig.operate === 2 && armCheckTestHide) ||
      (noArmCompleteConfig.operate === 2 && armCheckTestComplete)
    );
  }

  changeValid(val: number) {
    if (val !== 1) {
      this.validFail = false;
      this.$emit("setBar", false);
    }
  }

  rules = {};

  configOptions = [
    { name: "忽略", value: 0 },
    { name: "提示，可支持跳过", value: 1 },
    { name: "阻断，不可跳过", value: 2 }
  ];

  beforeAvatarUpload(file: any) {
    const type = file.name.split(".")[file.name.split(".").length - 1];
    console.log(type);
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!["jpg", "jpeg", "png"].includes(type)) {
      this.$message.error("图片格式不符!");
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 2MB!");
    }
    return ["jpg", "jpeg", "png"].includes(type) && isLt2M;
  }

  checkConfig(value: any, key: string) {
    if (value === 2 && this.configData[key].operate === 1) {
      this.configData[key].operate = 2;
    }
    if (value === 1 && this.configData[key].operate === 2) {
      this.configData[key].operate = 1;
    }
  }

  uploadImg(data: { filename: string; file: File }) {
    const { file } = data;
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway.upload(postRes, file).then((res: any) => {
          this.configData.wsaCodeUrl = tempUrl;
          this.$emit("setBar", false);
        });
      }
    });
  }

  onMainSwitchChange(e: any) {
    console.log("🚀 ~ onMainSwitchChange:", e);
  }

  syncNumLimit(val: number) {
    this.configData.noArmCompleteConfig.numberLimit = val;
  }

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck() {
    return new Promise((resolve, reject) => {
      (this.$refs.formRef as any)
        .validate()
        .then(() => {
          if (
            this.formItemData.handDetection.use === 1 &&
            this.hasCut &&
            !this.configData.wsaCodeUrl
          ) {
            this.validFail = true;
            resolve("handDetection");
          } else {
            //!形体检测只能在 setWeb 下使用，这里的校验也要做判断，不然上面👆的元素隐藏后，这里的 validate 会报错
            if (this.setWeb) {
              (this.$refs.bodyFormRef as any)
                .validate()
                .then(() => {
                  resolve("");
                })
                .catch(() => {
                  resolve("handDetection");
                });
            } else {
              resolve("");
            }
          }
        })
        .catch(() => {
          resolve("handDetection");
        });
    });
  }

  mounted() {
    if (!this.hasDetectItem) {
      this.formItemData.handDetection.configData.fingerCheckTestComplete = true;
      this.formItemData.handDetection.configData.fingerCheckTestFlexible = true;
      this.formItemData.handDetection.configData.fingerCheckTestScar = true;
    }
    if (this.configData.noRollUpSleevesConfig.numberLimit === 0) {
      this.configData.noRollUpSleevesConfig.numberLimit = this.configData.noArmCompleteConfig.numberLimit = 1;
    }
  }
}
